// app.routes.ts - Fixed IFrame Routes
import {FrameComponent} from './core/components/frame/frame.component';
import {IframeComponent} from './shared/components/iframe/iframe.component';
import {AuthGuardService} from './core/services/auth-guard.service';
import {Routes} from '@angular/router';
import {ExternalLinkComponent} from './shared/components/external-link/external-link.component';

export default [
  {
    path: '',
    component: FrameComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: 'home',
        loadChildren: async () => (await import('./features/main-home/main-home.routes')).mainHomeRoutes,
        canActivate: [AuthGuardService],
      },

      // ===== BRIEFING ROUTES =====
      {
        path: 'briefing',
        canActivate: [AuthGuardService],
        data: {
          role: 'briefing',
        },
        children: [
          {
            path: 'anzeigen',
            component: IframeComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'briefing:anzeigen',
              url: 'briefing/anzeigen',
              target: 'iframe',
              title: 'Briefing - Anzeigen',
            }
          },
        ]
      },

      // ===== BUCHEN ROUTES =====
      {
        path: 'buchen',
        canActivate: [AuthGuardService],
        data: {
          role: 'buchen',
        },
        children: [
          {
            path: 'anzeigen',
            component: IframeComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'buchen:anzeigen',
              url: 'buchen/anzeigen',
              target: 'iframe',
              title: 'Buchen - Anzeigen',
            }
          },
          {
            path: 'anzeigentool',
            component: IframeComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'buchen:anzeigen_tool',
              url: 'buchen/anzeigentool',
              target: 'tab',
              title: 'Buchen - Anzeigentool',
            }
          },
          {
            path: 'atv',
            component: IframeComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'buchen:atv',
              url: ('buchen/atv'),
              target: 'iframe',
              title: 'Buchen - ATV',
            }
          },
          {
            path: 'digital_adunit',
            canActivate: [AuthGuardService],
            data: { role: 'buchen:digital_adunit' },
            children: [
              {
                path: '',
                component: IframeComponent,
                canActivate: [AuthGuardService],
                data: {
                  role: 'buchen:digital_adunit',
                  url: 'buchen/digital',
                  target: 'iframe',
                  title: 'Buchen - Digital',
                }
              },
              {
                path: 'kunden',
                component: IframeComponent,
                canActivate: [AuthGuardService],
                data: {
                  role: 'buchen:digital_adunit:kunden',
                  url: 'buchen/digital/kunden',
                  target: 'iframe',
                  title: 'Buchen - Digital - Kunden',
                }
              },
              {
                path: 'werbemittel',
                component: IframeComponent,
                canActivate: [AuthGuardService],
                data: {
                  role: 'buchen:digital_adunit:werbemittel',
                  url: 'buchen/digital/werbemittel',
                  target: 'iframe',
                  title: 'Buchen - Digital - Werbemittel',
                }
              },
              {
                path: 'spezifikationen',
                loadChildren: async () => (await import('./features/meta-nav/meta-nav.routes')).spezifikationenRoutes,
                canActivate: [AuthGuardService],
                data: {
                  role: 'buchen:digital_adunit'
                }
              }
            ]
          },
          {
            path: 'instore',
            component: IframeComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'buchen:instore',
              url: ('buchen/instore'),
              target: 'iframe',
              title: 'Buchen - Instore',
            }
          },
          {
            path: 'mailing',
            component: IframeComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'buchen:mailing',
              url: ('buchen/mailing'),
              target: 'iframe',
              title: 'Buchen - Mailing',
            }
          },
          {
            path: 'ooh',
            component: IframeComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'buchen:out_of_home',
              url: ('buchen/ooh'),
              target: 'iframe',
              title: 'Buchen - Out of Home',
            }
          },
          {
            path: 'prospekt',
            component: IframeComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'buchen:prospekt',
              url: ('buchen/prospekt'),
              target: 'iframe',
              title: 'Buchen - Prospekt',
            }
          },
          {
            path: 'satellite-crm',
            component: ExternalLinkComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'buchen:satellite_crm',
              url: ('buchen/satellite-crm'),
              title: 'Buchen - Satellite CRM',
            },
          }
        ]
      },

      // ===== DASHBOARDS ROUTES =====
      {
        path: 'dashboards',
        canActivate: [AuthGuardService],
        data: {
          role: 'reports',
        },
        children: [
          {
            path: 'digital_adunit',
            component: IframeComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'reports:digital_adunit',
              url: ('dashboards/digital_adunit'),
              target: 'iframe',
              title: 'Dashboards - Digital',
            }
          },
          {
            path: 'digitales_prospekt',
            component: IframeComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'reports:digitales_prospekt',
              url: ('dashboards/digitales_prospekt'),
              target: 'iframe',
              title: 'Dashboards - Digitales Prospekt',
            }
          },
          {
            path: 'reklamationen',
            component: IframeComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'reports:reklamationen',
              url: ('dashboards/reklamationen'),
              target: 'iframe',
              title: 'Dashboards - Reklamationen',
            }
          },
        ]
      },

      // ===== WERBEGEBIETE ROUTES =====
      {
        path: 'gebiete',
        canActivate: [AuthGuardService],
        data: {
          role: 'gebiete',
        },
        children: [
          {
            path: 'bearbeiten',
            loadChildren: async () => (await import('./features/advertising-areas/advertising-areas.routes')).advertisingAreasRoutes,
            canActivate: [AuthGuardService],
            data: {
              role: 'gebiete:bearbeiten'
            }
          },
          {
            path: 'daten-exportieren',
            component: IframeComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'gebiete:dateiexport',
              url: ('gebiete/daten-exportieren'),
              target: 'iframe',
              title: 'Werbegebiete - Daten exportieren',
            }
          },
          {
            path: 'mediamaps',
            component: IframeComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'gebiete:media_maps',
              url: ('gebiete/mediamaps'),
              target: 'tab',
              title: 'Werbegebiete - MediaMaps',
            }
          },
        ]
      },


      {
        path: 'stammdaten',
        canActivate: [AuthGuardService],
        data: {
          role: 'stammdaten',
        },
        children: [
          {
            path: '',
            loadChildren: async () => (await import('./features/stammdaten-home/stammdaten-home.routes')).stammdatenHomeRoutes,
            pathMatch: 'full',
          },
          {
            path: 'filialen',
            loadChildren: async () => (await import('./features/branch/branch.routes')).branchRoutes,
            canActivate: [AuthGuardService],
            data: {
              role: 'stammdaten:filialen',
            }
          },
          {
            path: 'firmen',
            loadChildren: async () => (await import('./features/company/company.routes')).companyRoutes,
            canActivate: [AuthGuardService],
            data: {
              role: 'stammdaten:firmen',
            }
          },
          {
            path: 'medien',
            loadChildren: async () => (await import('./features/media/media.routes')).mediaRoutes,
            canActivate: [AuthGuardService],
            data: {
              role: 'stammdaten:medien',
            }
          },
          {
            path: 'produkte',
            loadChildren: async () => (await import('./features/product/product.routes')).productRoutes,
            canActivate: [AuthGuardService],
            data: {
              role: 'stammdaten:produkte',
            }
          },
          {
            path: 'konditionsverwaltung',
            loadChildren: async () => (await import('./features/condition/condition.routes')).conditionRoutes,
            canActivate: [AuthGuardService],
            data: {
              role: 'stammdaten:konditionsverwaltung',
            }
          },
          {
            path: 'ansprechpartner',
            loadChildren: async () => (await import('./features/contact-person/contact-person.routes')).contactPersonRoutes,
            canActivate: [AuthGuardService],
            data: {
              role: 'stammdaten:ansprechpartner',
            }
          },
          {
            path: 'faq',
            loadChildren: async () => (await import('./features/meta-nav/meta-nav.routes')).metaNavRoutes,
            canActivate: [AuthGuardService],
            data: {
              role: 'stammdaten:faq',
            }
          }
        ]
      },

      // ===== REKLAMATION ROUTES =====
      {
        path: 'reklamation',
        component: IframeComponent,
        canActivate: [AuthGuardService],
        data: {
          role: 'reklamation',
          url: ('reklamation'),
          target: 'tab',
          title: 'Reklamation',
        }
      },

      // ===== IMPORT ROUTES =====
      {
        path: 'import',
        canActivate: [AuthGuardService],
        data: {
          role: 'import',
        },
        children: [
          {
            path: 'address-updates',
            component: IframeComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'import:addressupdates',
              url: ('import-address-updates'),
              target: 'iframe',
              title: 'Import - Adressupdates',
            }
          },
          {
            path: 'edition-updates',
            component: IframeComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'import:auflagenaktualisierung',
              url: ('import-edition-updates'),
              target: 'iframe',
              title: 'Import - Auflagenaktualisierung',
            }
          },
          {
            path: 'payback-data',
            component: IframeComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'import:payback_daten',
              url: ('import-payback-data'),
              target: 'iframe',
              title: 'Import - Payback-Daten',
            }
          },
          {
            path: 'distribution-data',
            component: IframeComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'import:verbreitungsdaten',
              url: ('import-distribution-data'),
              target: 'iframe',
              title: 'Import - Verbreitungsdaten',
            }
          },

          {
            path: 'competitor-locations',
            component: IframeComponent,
            canActivate: [AuthGuardService],
            data: {
              role: 'import:wettbewerberstandorte',
              url: ('import-competitor-locations'),
              target: 'iframe',
              title: 'Import - Wettbewerber',
            },
          },
        ]
      },

      // ===== GENERIC IFRAME ROUTES =====
      {
        path: 'iframe',
        component: IframeComponent,
        canActivate: [AuthGuardService],
        data: {
          title: 'External Application'
        }
      },

      // External tools with dynamic parameters
      {
        path: 'external/:service',
        component: IframeComponent,
        canActivate: [AuthGuardService],
        data: {
          title: 'External Service'
        }
      },

      // ===== DEFAULT ROUTES =====
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: '**',
        redirectTo: '/',
      }
    ]
  },
] as Routes;
